import {Component, Input, Output, EventEmitter, SimpleChanges, ViewChild, OnChanges, OnInit} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../services/auth.service";
import {Observable} from "rxjs";
import {MicroSelectComponent} from "../shared/select/micro-select.component";
import {NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
  selector: 'micro-user-select',
  templateUrl: './user-select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: UserSelectComponent
    }
  ]
})
export class UserSelectComponent implements OnInit, OnChanges  {

  @ViewChild("sel", {static: true}) sel:MicroSelectComponent;

  @Output()
  userIdChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  userId:any;

  @Input()
  departmentId:any;

  @Input()
  companyId:any;

  @Output()
  valueChange:EventEmitter<any> = new EventEmitter<any>();

  @Output()
  userChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  value:any = '';

  @Input()
  required:boolean = false;

  @Input()
  disabled:boolean = false;

  @Input()
  searchable: boolean = true;

  @Input()
  jump: boolean = true;

  options:any[];

  onChange = (userId) => {};
  onTouched = () => {};
  touched = false;

  change(e) {
    this.userIdChange.emit(e);
    this.userChange.emit(this.options.find(o => o.id === e) || null)
    this.valueChange.emit(this.sel.getSelectedValue());
  }

  constructor(private auth:AuthService, private env:EnvService, private http:HttpClient) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (let prop in changes) {
      if ((prop === 'departmentId' || prop === 'companyId') && this.options) {
        this.reload();
      }
    }
  }

  reload() {
    if (this.requires()) {
      this.options = [];
      //this.change('');
      return;
    }

    this.sel.loading = true;
    let params:HttpParams = new HttpParams();

    if (this.departmentId) {
      params = params.set("departmentId", this.departmentId);
    }

    if (this.companyId) {
      params = params.set("companyId", this.companyId);
    }

    return this.http.get(`${this.env.e.url}/auth/users/all`, {params:params})
      .subscribe(data => {
        this.options = data as any[];
        this.sel.loading = false;
      });
  }

  registerOnChange(onChange: any): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  writeValue(userId: string): void {
    this.userId = userId;
  }

  ngOnInit(): void {
    this.reload();
  }

  requires() {
    // if (!this.companyId || this.companyId === '') {
    //   return "--COMPANY--";
    // }
    //
    // if (!this.departmentId || this.departmentId === '') {
    //   return "--DEPARTMENT--";
    // }

    return null;
  }
}
